import Image from "next/image";
import React from "react";
import { productLinks, quickLinks, solutionsLinks } from "./data";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import AiSummaryLinks from "../aiSummaryLinks/aiSummaryLinks.component";

interface FooterLinkColumnProps {
  heading: string;
  links: { title: string; href: string }[];
  linkClassName: string;
  columnClassName?: string;
}

function FooterLinkColumn({
  heading,
  links,
  linkClassName,
  columnClassName,
}: FooterLinkColumnProps) {
  return (
    <div className={cn("flex flex-col xs:items-start items-center gap-4", columnClassName)}>
      <h3 className="text-secondary-foreground text-lg font-semibold tracking-[-0.17px] leading-7">
        {heading}
      </h3>

      <div className="flex flex-col xs:items-start items-center gap-3">
        {links.map((link, index) => (
          <Link
            key={index}
            href={link.href}
            className={cn(
              "transition-colors xs:text-start text-center",
              linkClassName,
            )}
          >
            {link.title}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default function FooterMain() {
  const pathname = usePathname();
  const linkClassName = cn({
    "text-footer-link hover:text-footer-link-hover": pathname === "/",
    "text-white/90": pathname === "/customers",
  });

  return (
    <div className="flex flex-col md:flex-row flex-wrap xs:items-start items-center justify-center md:justify-between md:gap-10 gap-8 w-full py-6">
      {/* App promotion section */}
      <div className="flex flex-col xs:items-start items-center md:gap-8 gap-6 w-full lg:max-w-[22rem] md:max-w-[18rem] max-w-[30rem]">
        <Image
          className="object-contain h-auto w-auto"
          alt="Fydo Logo"
          src="/icons/FYDO.png"
          width={100}
          height={16}
        />
        <div>
          <h2 className="font-semibold text-white lg:text-4xl md:text-4xl sm:text-5xl xs:text-3xl text-3xl leading-[120%] xs:text-start text-center ">
            Built for Shops
          </h2>
          <h2 className="font-semibold text-white lg:text-4xl md:text-4xl sm:text-5xl xs:text-3xl text-3xl leading-[120%] xs:text-start text-center ">
            Loved by Shoppers.
          </h2>
        </div>
        <p
          className={cn(
            " text-base xs:max-w-[80%]  leading-[170%] xs:text-start text-center",
            {
              "text-footer-link": pathname === "/",
              "text-white/90": pathname === "/customers",
            }
          )}
        >
          {`Loved by those who sell. Loved by those who shop. Loyalty, the Fydo way : )`}
        </p>
        <AiSummaryLinks />
      </div>

      <FooterLinkColumn
        heading="Product"
        links={productLinks}
        linkClassName={linkClassName}
      />
      <FooterLinkColumn
        heading="Solutions"
        links={solutionsLinks}
        linkClassName={linkClassName}
      />
      <FooterLinkColumn
        heading="Company"
        links={quickLinks}
        linkClassName={linkClassName}
      />
    </div>
  );
}
